export var All = '@@ALL';